import moment from 'moment';

let changeFormatHelper = (time) => {
    let countryCode = localStorage.getItem('country_code');
    if (countryCode == "AU") {
        return moment(time).format('DD/MM/YYYY')
    } else if (countryCode == "US") {
        return moment(time).format('MM/DD/YYYY')
    } else {
        return moment(time).format('MM/DD/YYYY')
    }
}

let changeFormatWithDateTime = (time) => {
    let countryCode = localStorage.getItem('country_code');
    if (countryCode == "AU") {
        return moment(time).format('DD/MM/YYYY hh:mm A')
    } else if (countryCode == "US") {
        return moment(time).format('MM/DD/YYYY hh:mm A')
    } else {
        return moment(time).format('MM/DD/YYYY hh:mm A')
    }
}

let formatBirthdayString = () => {
    let countryCode = localStorage.getItem('country_code');
    if (countryCode == "AU") {
      return 'dd/MM';
    } else if (countryCode == "US") {
      return 'MM/dd';
    } else {
      return 'MM/dd';
    }
}

let formatExportDateString = () => {
    let countryCode = localStorage.getItem('country_code');
    if (countryCode == "AU") {
        return 'DD-MM-YYYY';
    } else if (countryCode == "US") {
        return 'MM-DD-YYYY';
    } else {
        return 'MM-DD-YYYY';
    }
}

let formatExportUnderscoreDateString = () => {
    let countryCode = localStorage.getItem('country_code');
    if (countryCode == "AU") {
        return 'DD_MM_YYYY';
    } else if (countryCode == "US") {
        return 'MM_DD_YYYY';
    } else {
        return 'MM_DD_YYYY';
    }
}

let changeFormatWeek = (time) => {
  let countryCode = localStorage.getItem('country_code');
  if (countryCode == "AU") {
      return moment(time).format('DD/MM')
  } else if (countryCode == "US") {
      return moment(time).format('MM/DD')
  } else {
      return moment(time).format('MM/DD')
  }
}

let formatDateString = () => {
    let countryCode = localStorage.getItem('country_code');
    if (countryCode == "AU") {
      return 'DD/MM/YYYY';
    } else if (countryCode == "US") {
      return 'MM/DD/YYYY';
    } else {
      return 'MM/DD/YYYY';
    }
}

let formatWaitListDate = (time) => {
    let countryCode = localStorage.getItem('country_code');
    if (countryCode == "AU") {
      return moment(time).format('DD/MM/YY');
    } else if (countryCode == "US") {
      return moment(time).format('MM/DD/YY');
    } else {
      return moment(time).format('MM/DD/YY');
    }
}

export { changeFormatHelper, changeFormatWithDateTime , formatBirthdayString, changeFormatWeek, formatExportDateString, formatDateString, formatExportUnderscoreDateString, formatWaitListDate };
